import { ContactDetailsFormProps } from '@/src/components/common/forms/contactDetailsForm'
import { Customer } from '@/src/types/itinerary'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useGetSaveTravelerData } from '../../useLoadUserData'

export const useContactDetails = (
    customer: Customer,
    defaultMobileCountryCode: '966' | '971' = '966'
) => {
    const { userData } = useGetSaveTravelerData()
    const initialContactDetails: Customer = useMemo(() => {
        return {
            ...customer,
            email: customer.email || userData?.customer?.email || '',
            mobile: customer.mobile || userData?.customer?.mobile || '',
            mobileCountryCode: customer.mobileCountryCode || userData?.customer?.mobileCountryCode?.replace('+', '') || defaultMobileCountryCode
        }
    }, [customer, userData?.customer])

    const [contactDetails, setContactDetails] = useState<Customer>(initialContactDetails)

    const onChangeContactDetails: ContactDetailsFormProps['onChange'] = useCallback((key, value) => {
        const isString = typeof value === 'string'
        setContactDetails(prev => ({
            ...prev,
            [key]: isString ? value.trim() : value
        }))
    }, [])

    useEffect(() => {
        if ((userData?.customer?.email && !contactDetails.email) || (userData?.customer?.mobile && !contactDetails.mobile) || (userData?.customer?.mobileCountryCode && !contactDetails.mobileCountryCode)) {
            setContactDetails(prev => ({
                ...prev,
                email: userData?.customer?.email || '',
                mobile: userData?.customer?.mobile || '',
                mobileCountryCode: userData?.customer?.mobileCountryCode?.replace('+', '') || defaultMobileCountryCode
            }))
        }
    }, [userData?.customer])

    return {
        contactDetails,
        setContactDetails,
        onChangeContactDetails
    }
}
